export class DeepMap<TKey, TVal> {
    get(path: TKey[]): TVal | undefined {
        const node = this.__getNodeAt(path);
        return node?.item;
    }

    set(path: TKey[], value: TVal): this {
        const node = this.__getNodeAt(path, {create: true});
        node.item = value;
        return this;
    }

    private readonly __root = new Map<TKey, DeepMapPathNode<TKey, TVal>>();

    private __getNodeAt(path: TKey[], opt: {create: true}): DeepMapPathNode<TKey, TVal>;
    private __getNodeAt(path: TKey[], opt?: {create: boolean}): DeepMapPathNode<TKey, TVal> | undefined;
    private __getNodeAt(path: TKey[], {create = false}: {create?: boolean} = {}) {
        const {__root: root} = this;
        let current = new DeepMapPathNode(root);
        for (const node of path) {
            if (current.children === undefined) {
                current.children = new Map();
            }
            let next = current.children.get(node);
            if (next === undefined) {
                if (!create) {
                    return;
                }
                next = new DeepMapPathNode();
                current.children.set(node, next);
            }
            current = next;
        }
        return current;
    }
}

class DeepMapPathNode<TKey, TVal> {
    constructor(
        public children: Map<TKey, DeepMapPathNode<TKey, TVal>> | undefined = undefined,
        public item: TVal | undefined = undefined
    ) {}
}
